import { washData } from '@/components/common/controlBar/utils.js'
import {extraNode, walkNode} from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'
import { getAuthInfo, getCurrentModule } from '@/utils.js'
import {extraProperty, formatWatch} from "@/store/source.js";
import {isCustomModule} from "@/composables/staticSource.js";


const _ = {
  state: {
    currentModule: null,
    currentPage: null,
    list: []
  },
  mutations: {
    SET_MODULE_LIST: (state, data) => {
      state.list = data
    }
  },
  actions: {
    SelectTemplate({ commit, rootState }, data) {
      return mm
        .http({
          url: '/ksh/template/selectTemplate',
          method: 'post',
          data
        })
        .then(async ({ data }) => {
          return data
        })
    },
    TemplatePreview({ commit, rootState }, params) {
      return mm
        .http({
          url: '/ksh/template/preview',
          method: 'get',
          params
        })
        .then(async ({ data }) => {
          return data
        })
    },
    GetTemplateSearchList({ commit, rootState }, params) {
      return mm
        .http({
          url: '/ksh/template/searchList',
          method: 'get',
          params
        })
        .then(async ({ data }) => {
          return data
        })
    },
    GetTemplateList({ commit, rootState }, params) {
      return mm
        .http({
          url: '/ksh/template/list',
          method: 'get',
          params
        })
        .then(async ({ data }) => {
          return data
        })
    },
    GetWidgetsList({ commit, rootState }, params) {
      return mm
        .http({
          url: '/api/control/list',
          method: 'get',
          params
        })
        .then(async ({ data }) => {

          data.list = data.list.map((firstCategory) => {
            if (firstCategory.children)
              firstCategory.list = firstCategory.children.map((secondCategory) => {
                if (secondCategory.children) secondCategory.list = secondCategory.children
                else
                  secondCategory.list = secondCategory.control_list.map((thirdCategory) => {

                    thirdCategory = extraProperty(thirdCategory)
                    return thirdCategory
                  })
                return secondCategory
              })
            else
              firstCategory.list = firstCategory.control_list.map((secondCategory) => {

                secondCategory = extraProperty(secondCategory)

                return secondCategory
              })
            return firstCategory
          })


          walkNode({
            ...data,
            isRoot: true
          }, (walkedNode)=>{
            if(!walkedNode.isRoot && !walkedNode.list){
              walkedNode.list = walkedNode.children
            }
            if(
              walkedNode.name === '产品简介' ||  //
              walkedNode.name === '产品图文' ||  // 1
              walkedNode.name === '产品详情' || //
              walkedNode.name === '产品Attribute' || //
              walkedNode.name === 'CTA' ||
              walkedNode.name === '单页详情' || //
              walkedNode.name === '新闻详情' || //
              walkedNode.name === '案例详情' || //
              walkedNode.name === '展开收起-标签' || //
              walkedNode.name === '展开收起-文本' //
            ){

              formatWatch(walkedNode)
            }

          })

          window.controlListData = data

          var navItem = data.list.find((item) => {
            return item.name === '导航'
          })
          if (navItem) {
            // nav_type 1 顶部导航，2 测导航
            if (mm.store.state.module.currentPage?.nav_type === 1) {
              navItem.children = navItem.children.filter((item) => {
                return item.name !== '侧边导航'
              })
            } else {
              navItem.children = navItem.children.filter((item) => {
                return item.name !== '顶部导航'
              })
            }
          }







          rootState.list[1].list = data.list


          commit('UPDATE_LIST', rootState.list)
          return data
        })
    },
    GetModuleList({ commit, rootState }, params) {
      return mm
        .http({
          url: '/api/module/list',
          method: 'get',
          params
        })
        .then(async ({ data }) => {

          walkNode({
            ...data,
            isRoot: true
          }, (walkedNode)=>{

            if(!walkedNode.isRoot && !walkedNode.list){
              walkedNode.list = walkedNode.module_list
            }
            if(
              walkedNode.name === 'CTA'
            ){
              formatWatch(walkedNode)
            }

          })


          window.moduleListData = data
          commit('SET_MODULE_LIST', data.list)


          rootState.list[0].list = data.list.map((firstCategory) => {
            if (firstCategory.children)
              firstCategory.list = firstCategory.children.map((secondCategory) => {
                if (secondCategory.children) secondCategory.list = secondCategory.children
                else
                  secondCategory.list = secondCategory.module_list.map((thirdCategory) => {
                    thirdCategory = extraProperty(thirdCategory, true)
                    return thirdCategory
                  })
                return secondCategory
              })
            else
              firstCategory.list = firstCategory.module_list.map((secondCategory) => {
                secondCategory = extraProperty(secondCategory, true)
                return secondCategory
              })
            return firstCategory
          })


          commit('UPDATE_LIST', rootState.list)


        })
    },
    CreateModule(_, data) {
      return mm
        .http({
          url: '/api/module/create',
          method: 'post',
          data
        })
        .then(({ data }) => {
          return data
        })
    },
    GetModuleDetail({ commit, state }, params) {
      var moduleData = getCurrentModule()
      function transformDataConstrucotr() {
        const resList = [
          extraNode({
            name: '空白模块',
            componentName: 'module',
            _type: 'module1'
          })
        ]
        const content = { list: [] }
        if (Object.keys(moduleData.content).length) {
          content.list.push(moduleData.content)
        } else {
          content.list.push(resList[0])
        }
        return [content, resList]
      }

      var [content, resList] = transformDataConstrucotr()

      washData({ content })

      const newList = (() => {
        if (content.list.length) {
          content.list = content.list.map((baseNode) => {
            return extraNode(baseNode, true)
          })
          return content.list
        } else {
          return [...resList]
        }
      })()
      mm.utils.formatListName(newList)
      commit('UPDATE_HAS_LIST', newList)
    },
    EditModule(_, data) {
      return mm
        .http({
          url: '/api/module/edit',
          method: 'post',
          data
        })
        .then(({ data }) => {
          return data
        })
    },
    DeleteModule(_, data) {
      return mm
        .http({
          url: '/api/module/delete',
          method: 'post',
          data
        })
        .then(({ data }) => {
          return data
        })
    },
    updateThemeConfig(_, data) {
      return mm
        .http({
          url: '/ksh/updateGlobalThemeColor',
          method: 'post',
          data
        })
        .then(({ data }) => {
          return data
        })
    },
    updateSafeRangeConfig(_, data) {
      return mm
        .http({
          url: '/ksh/updateSafetyRange',
          method: 'post',
          data
        })
        .then(({ data }) => {
          return data
        })
    }
  }
}

export default _
